import { render, staticRenderFns } from "./photoCfgModal.vue?vue&type=template&id=22c1dd12"
import script from "./photoCfgModal.vue?vue&type=script&lang=js"
export * from "./photoCfgModal.vue?vue&type=script&lang=js"
import style0 from "./photoCfgModal.vue?vue&type=style&index=0&id=22c1dd12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports